import { PropsWithChildren } from "react"
import { Tooltip as ReactTooltip } from "react-tooltip"
import styled from "styled-components"

import "./tooltip.css"

import tooltipIcon from "assets/svg/tooltip-icon.svg"

import styles from "./index.module.scss"

const Container = styled.div<{ isDark: boolean }>`
  ${props =>
    props.isDark &&
    `
   div {
      background-color: #000;

      &:nth-child(1) {
        display: none;
      }

      &:nth-child(2) {
        color: #eeeeee;
        font-weight: 400;
        padding: 12px;
        font-size: 12px;
        max-width: 185px;
        text-align: center;
      }
    }
  `}
`

const StyledTooltipText = styled.span`
  font-size: 0.75rem;
  color: #64748b;

  &::after {
    position: relative;
    top: 2px;
    margin-left: 2px;
    content: url("${tooltipIcon}");
  }
`
interface Props extends PropsWithChildren {
  id: string
  text?: string
  className?: string
  variant?: "light" | "dark"
  orientation?: "top" | "bottom" | "left" | "right" | "top-start" | "bottom-start" | "bottom-end"
  delay?: number
}
export const Tooltip = ({ children, id, text = "", orientation = "top-start", className, variant, delay }: Props) => {
  return (
    <Container className={className} isDark={variant === "dark"}>
      <StyledTooltipText data-tooltip-id={id}>{text}</StyledTooltipText>
      <ReactTooltip
        classNameArrow={styles.tooltipArrow}
        className={styles.tooltip}
        place={orientation}
        id={id}
        variant={variant || "light"}
        delayShow={delay}
      >
        {children}
      </ReactTooltip>
    </Container>
  )
}
